import { Component, forwardRef, Input } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
  selector: 'app-month-picker',
  standalone: true,
  template:
    '<p-datepicker [inputId]="id" [class]="class" [iconDisplay]="\'input\'" [showIcon]="showIcon" [placeholder]="placeholder" [disabled]="disabled" [(ngModel)]="date" (ngModelChange)="onChange($event)" (onBlur)="onTouched()" [appendTo]="appendTo" view="month" dateFormat="Myy" [readonlyInput]="true"></p-datepicker>',
  imports: [FormsModule, DatePickerModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MonthPickerComponent),
      multi: true,
    },
  ],
})
export class MonthPickerComponent implements ControlValueAccessor {
  @Input() placeholder?: string = 'MMyy';
  @Input() class?: string = 'w-full';
  @Input() disabled: boolean | string = false;
  @Input() id?: string;
  @Input() appendTo?: string;

  date: Date | null = null;
  showIcon: boolean = true;
  selectedYearMonth: string = '';


  writeValue(value: string | Date | null): void {
    if (!value) {
      this.date = null;
      return;
    }

    if (value instanceof Date) {
      this.date = value;
    } else if (typeof value === 'string' && /^\d{6}$/.test(value)) {
      const year = +value.substring(0, 4);
      const month = +value.substring(4, 6) - 1;
      this.date = new Date(year, month, 1);
    } else {
      this.date = null;
    }
  }

  private onChangeFn: (value: any) => void = () => { };
  private onTouchedFn: () => void = () => { };

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  onChange(date: Date | null): void {
    if (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const formatted = `${year}${month}`;
      this.selectedYearMonth = formatted;
      this.onChangeFn(formatted);
    } else {
      this.selectedYearMonth = '';
      this.onChangeFn(null);
    }
  }

  onTouched(): void {
    this.onTouchedFn();
  }

  setDisabledState?(isDisabled: boolean): void {
    this.showIcon = !isDisabled;
    this.disabled = isDisabled;
  }
}
